// extracted by mini-css-extract-plugin
export default {"Btn":"Btn_Btn__+M8OR"};